import {Component, OnInit} from '@angular/core';
import {environment} from "../../../environments/environment";


@Component({
  selector: 'app-not-found',
  template: `
    <h2 style="display: flex; font-size: x-large; justify-content: center;">
      Access Denied. Please contact McLane Helpdesk.
    </h2>
    <a style="display: flex; font-size: x-large; justify-content: center;" href="{{env.base_url}}">
      Click here to return to McLane Connect </a>
  `
})
export class NoAccessComponent implements OnInit {
  path: string;
  env = environment;

  constructor() {
  }

  ngOnInit() {
  }
}
